export default __webpack_public_path__ + "56922e1b12b433698b94ae89b3ea9cf5.svg";